/**
 * @file  paymentPlan/index.ts
 * @description  payment plan calculator
 *
 * @author ogarcia (ozkary)
 *
 */

import * as api from '../index';
import Payment, { Plan } from './paymentPlan.model';

/**
 * calculates the payment information
 * @param data payment information
 * @returns the plan information with taxes and fees
 */
export const getPlan = async (data: Payment): Promise<Plan> => {
  const { submit } = api;
  const result: Plan = await submit<Payment, Plan>('payment-plan', data);

  // Adding retail down payment information to suport tax not included views.
  const retailDown = result.total * (result?.downRate ?? 0);
  const retailMonthly = (result.total - retailDown) / result.installments;

  const paymentPlan = {
    ...result,
    retailDown,
    retailMonthly: Number(parseFloat(retailMonthly.toString()).toFixed(2))
  };

  return paymentPlan;
};
